// types/employee.ts

/** 佣金类型 */
export type CommissionType = 'locker' | 'tracker' | 'promoter'

/** 佣金状态: 1-正常, 2-已扣除, 3-部分扣除 */
export type CommissionStatus = 1 | 2 | 3

/** 员工订单列表项 */
export interface EmployeeOrder {
  id: number
  order_id: number
  order_no: string
  pay_price: number
  user_phone: string
  real_name: string
  pay_time: string
  my_amount: number
  my_effective_amount: number
  my_commission_type: CommissionType
  my_status: CommissionStatus
}

/** 订单详情中的佣金分配 */
export interface EmployeeOrderCommission {
  id: number
  user_id: number
  user_name: string
  commission_type: CommissionType
  profit: number
  rate: number
  amount: number
  deducted_amount: number
  effective_amount: number
  status: CommissionStatus
}

/** 商品信息 */
export interface CartInfoItem {
  cart_id: string
  product_id: number
  product_name: string
  product_image: string
  product_attr: string
  cart_num: number
  price: number
  total_price: number
  pay_price?: number // 实付小计（促销组合分摊后），无促销时与 total_price 一致
}

/** 订单详情中的订单信息 */
export interface EmployeeOrderInfo {
  id: number
  order_id: string
  real_name: string
  user_phone: string
  user_address: string
  total_num: number
  total_price: number
  pay_price: number
  status: number
  refund_type: number
  add_time: string
  paid: number
  paid_time: string
  delivery_name: string
  delivery_id: string
  mark: string
  remark: string
}

/** 员工订单详情响应 */
export interface EmployeeOrderDetailResponse {
  order: EmployeeOrderInfo
  cart_infos: CartInfoItem[]
  commissions: EmployeeOrderCommission[]
}

/** 员工订单列表查询参数 */
export interface EmployeeOrderListParams {
  page: number
  page_size: number
  order_no?: string
  phone?: string
  user_id?: number
  date?: string
}

/** 佣金类型标签 */
export const commissionTypeLabels: Record<CommissionType, string> = {
  locker: '锁客',
  tracker: '跟进',
  promoter: '推广',
}

/** 佣金状态标签 */
export const commissionStatusLabels: Record<CommissionStatus, string> = {
  1: '正常',
  2: '已扣除',
  3: '部分扣除',
}
